import { styled } from "@mui/material/styles";

export const BoxButton = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  marginTop: "16px",
}));
